// @/api/model/ContractManage.js

import config from "@/config";
import http from "@/utils/request";

export default {
	page: {
		url: `${config.MAIN_URL}/market/contract/contractManageList`,
		name: "合同管理分页查询",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	getClientCompany: {
		url: `${config.MAIN_URL}/market/contract/getClientCompany`,
		name: "客户单位下拉列表",
		get: async function () {
			return await http.get(this.url);
		},
	},
	/* getParentCompanyList: {
		url: `${config.MAIN_URL}/market/company/getParentCompanyList`,
		name: "合同状态",
		get: async function () {
			return await http.get(this.url);
		},
	}, */
	getcontractOperator: {
		url: `${config.MAIN_URL}/market/contract/getcontractOperator`,
		name: "经办人下拉",
		get: async function () {
			return await http.get(this.url);
		},
	},

	/* itemList: {
		url: `${config.MAIN_URL}/common/dic/itemList`,
		name: '获取字典数据',
		post: async function (data) {
			return await http.post(this.url, data);
		},
	}, */

	getFileInfo: {
		url: `${config.MAIN_URL}/market/contract/getFileInfo`,
		name: "文件上传数据回显-合同",
		get: async function (params) {
			return await http.get(this.url + params);
		},
	},


	addContract: {
		url: `${config.MAIN_URL}/market/contract/addContract`,
		name: '新增合同',
		post: async function (data) {
			return await http.post(this.url, data);
		},
	},
	updateContract: {
		url: `${config.MAIN_URL}/market/contract/updateContract`,
		name: "编辑合同",
		put: async function (data) {
			return await http.put(this.url, data);
		},
	},
	updateContractRate: {
		url: `${config.MAIN_URL}/market/contract/updateContractRate`,
		name: "编辑合同执行进度",
		put: async function (data) {
			return await http.put(this.url, data);
		},
	},
	deleteContract: {
		url: `${config.MAIN_URL}/market/contract/deleteContract`,
		name: "删除合同",
		delete: async function (params) {
			return await http.delete(this.url + params);
		},
	},

};
